import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';

function BlogCoachingVsTherapy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 via-white to-warm-50">
      <Navigation variant="soft-brown" scrolled={true} />
      
      {/* Article Header */}
      <section className="px-4 sm:px-6 lg:px-8 pt-32 pb-12">
        <div className="max-w-4xl mx-auto">
          <Link to="/blog" className="inline-flex items-center text-sage-600 hover:text-sage-800 mb-8 transition-colors">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Blog
          </Link>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-sage-800 mb-6">
            Do I Need Coaching or Therapy?
          </h1>
          
          <div className="flex items-center text-gray-600 text-sm mb-8">
            <span>By Yasi Philipos</span>
            <span className="mx-3">•</span>
            <span>6 min read</span>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg">
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              Coaching focuses on the present and future... building awareness, nervous system safety, and new patterns that align with your values and authentic self.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              Many clients experience profound transformation through coaching alone... it can be incredibly powerful work that helps you shift long-standing patterns, strengthen boundaries, and reconnect with your authentic self. Not everyone needs therapy to experience deep change.
            </p>

            <h2 className="text-2xl md:text-3xl font-serif font-light text-sage-800 mb-4 mt-8">
              When Therapy Goes Deeper
            </h2>

            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              <strong className="text-sage-800">Therapy includes everything coaching is... and goes deeper.</strong> It focuses on healing and processing past experiences, emotions, and trauma that may still be influencing how you show up today. Therapy provides a structured, licensed space for deeper emotional integration and lasting change.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              If you're unsure which path is right for you, I'll help you discern where to start based on your goals, needs, and what feels supportive right now.
            </p>

            <div className="bg-gradient-to-br from-sage-50 to-cream-50 rounded-2xl p-6 md:p-8 my-8 border border-sage-100">
              <h3 className="text-xl font-semibold text-sage-800 mb-4">Location Matters</h3>
              
              <p className="text-lg text-gray-600 leading-relaxed mb-4">
                <strong className="text-sage-800">If you live in California</strong> and, as we work together, we both feel that therapy would be beneficial, I'll discuss this with you openly. With your consent, we'll review what this transition would look like, and — if you wish to continue — I can move into therapy work with you after we've discussed all important details and boundaries.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed">
                <strong className="text-sage-800">If you live outside of California</strong> and need therapy or trauma processing beyond the scope of coaching, I'll help you find a qualified trauma therapist in your region.
              </p>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              Whether through coaching or therapy, my role is to support awareness, safety, and growth — helping you feel safe being more of yourself in every relationship and area of your life.
            </p>
          </div>

          {/* CTA at the bottom */}
          <div className="mt-12 bg-gradient-to-br from-sage-50 to-warm-50 rounded-3xl p-8 md:p-12 text-center border border-sage-100">
            <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 mb-4">
              Not sure where to start?
            </h3>
            <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
              Book a free 15-minute consultation and we'll explore together which approach feels right for you.
            </p>
            <Link to="/#booking" className="inline-block bg-warm-500 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-warm-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
              Book Free Consultation
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BlogCoachingVsTherapy;
